/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RouteSolutionDownloadDtoBase
 * auto generated base class for the model RouteSolutionDownloadDtoModel.
 */
export const RouteSolutionDownloadDtoModelBase = ModelBase
  .named('RouteSolutionDownloadDto')
  .props({
    __typename: types.optional(types.literal("RouteSolutionDownloadDto"), "RouteSolutionDownloadDto"),
    url: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RouteSolutionDownloadDtoModelSelector extends QueryBuilder {
  get url() { return this.__attr(`url`) }
}
export function selectFromRouteSolutionDownloadDto() {
  return new RouteSolutionDownloadDtoModelSelector()
}

export const routeSolutionDownloadDtoModelPrimitives = selectFromRouteSolutionDownloadDto().url
